module.exports = __webpack_public_path__ + "img/2-5-3.0919d2e5.png";